/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ name: NonNullable<unknown> }} Crosspostingconnectedas2Inputs */

const en_crosspostingconnectedas2 = /** @type {(inputs: Crosspostingconnectedas2Inputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Connected as ${i?.name}`)
};

const de_crosspostingconnectedas2 = /** @type {(inputs: Crosspostingconnectedas2Inputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Verbunden als ${i?.name}`)
};

/**
* | output |
* | --- |
* | "Connected as {name}" |
*
* @param {Crosspostingconnectedas2Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const crosspostingconnectedas2 = /** @type {((inputs: Crosspostingconnectedas2Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Crosspostingconnectedas2Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_crosspostingconnectedas2(inputs)
	return de_crosspostingconnectedas2(inputs)
});
export { crosspostingconnectedas2 as "crosspostingConnectedAs" }